import Scrollable from "@components/ui/Scrollable";
import { ComponentElem, ScrollableSetting } from "@components/interfaces";
import ApiProxy from "@ts/ApiProxy";
import { Index } from "./IndexTypes";
import { Common } from "@components/common/CommonTypes";

export default class IndexSortBar extends Scrollable
{
  constructor(elem: ComponentElem)
  {
    super(elem, {
      itemWidth: 0,
      itemHeight: 100,
      gapX: 10,
      gapY: 10,
      numCols: 13,
      buttonMode: "press"
    }, {
      itemWidth: 0,
      itemHeight: 120,
      gapX: 10,
      gapY: 10,
      numCols: 4,
      buttonMode: "press"
    });

    let $wrapper = this.$root.find(".wrapper"),
    $sample = $($wrapper.find(`[component="sort-button"]`)[0]).clone();

    $wrapper.empty();

    let searchPagePath = ApiProxy.getCommonPageData().search_page_path;

    ApiProxy.getCommonPageData().sort_data.forEach((data: Common.SortData)=>
    {
      let $item = $sample.clone();
      $item.find(".label").text(data.name);
      $item.find("img").attr("src", data.icon);
      $item.attr("href", `${searchPagePath}?sort=${data.name}`);

      $wrapper.append($item);
    });
  }
}